<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <Invira-user-form ref="form" v-model="form" :input-errors="inputErrors" :password-required="true" />
    </crud-create>
</template>

<script>
import UserProvider from "../../../providers/UserProvider";

import { CrudCreate } from "@dracul/common-frontend";
import { ClientError } from "../../../../../errors";

import InviraUserForm from "../InviraUserForm";

export default {
    name: "InviraUserCreate",

    components: { InviraUserForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "admin.inviraUser.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                username: null,
                email: null,
                password: null,
                companyId: null,
                roleId: null,
                depositoIds: [],
                active: true,
            },
        };
    },

    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                
                // Prepare data for creation
                const createData = { ...this.form };
                
                // Convert depositoIds to array of strings and filter to only include valid IDs
                // that are actually available in the depositos list (belong to user's company)
                const depositoIds = (this.form.depositoIds || []).map(id => String(id).trim())
                
                // Get depositos from form component to validate against
                const availableDepositoIds = this.$refs.form && this.$refs.form.depositos 
                    ? new Set(this.$refs.form.depositos.map(d => String(d.id).trim()))
                    : new Set()
                
                // Filter to only include depositos that are available for user's company
                createData.depositoIds = availableDepositoIds.size > 0
                    ? depositoIds.filter(id => availableDepositoIds.has(id))
                    : depositoIds // If no depositos loaded yet, send all (shouldn't happen in normal flow)
                
                UserProvider.createUser(createData)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.adminUserCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>

<style scoped></style>

